import React from "react";

export default class TextStatusViewer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: this.props.open || false,
    };

    this.onToggleTerms = this.onToggleTerms.bind(this);
  }

  render() {
    return (
      <div className="text-center" style={{marginTop: '10px'}}>
        <a href="#" onClick={this.onToggleTerms} style={{fontSize: '12px'}}>
          {I18n.t("terms_and_conditions")}
        </a>
        <div
          className={`terms-and-conditions-modal ${this.state.open ? "open" : ""}`}
          style={{ display: this.state.open ? "block" : "none" }}
        >
          <div dangerouslySetInnerHTML={{ __html:  this.renderTerms() }}></div>
          <button
            type="button"
            className="btn btn-secondary"
            style={{marginTop: '15px'}}
            onClick={this.onToggleTerms}
          >
            {I18n.t("close")}
          </button>
        </div>
      </div>
    );
  }

  renderTerms() {
    var terms = {};
    var terms_string = "";

    // bundle up all rate billing policy terms
    if (this.props.reservation_segments) {
      for (
        var i = 0, ilen = this.props.reservation_segments.length;
        i < ilen;
        i++
      ) {
        var reservation_segment = this.props.reservation_segments[i];
  
        if (
          reservation_segment &&
          reservation_segment.billing_policy
        ) {
          if (terms.hasOwnProperty(reservation_segment.billing_policy.id)) {
            terms[
              reservation_segment.billing_policy.id
            ].reservation_segments.push(reservation_segment);
          } else {
            terms[reservation_segment.billing_policy.id] = {
              terms: reservation_segment.billing_policy.terms,
              reservation_segments: [reservation_segment],
            };
          }
        }
      }
  
      for (var t in terms) {
        terms_string =
          terms_string +
          "<h4>" +
          terms[t].reservation_segments
            .map(function (reservation_segment) {
              return (
                reservation_segment.room_type.name +
                " - " +
                reservation_segment.rate.name
              );
            })
            .join(", ") +
          "</h4><hr /><div>" +
          (terms[t].terms ? terms[t].terms : "")
           + '</div>';
      }
    }

    return terms_string;
  }

  onToggleTerms(e) {
    e.preventDefault();
    this.setState({ open: !this.state.open });
  }
}
